import { LocalDateTime } from "@flockcover/flock-svc-core-types"
import { Period, LocalDateTime as JSJodaLocalDateTime } from "@js-joda/core"

export const reduceDateByOneHour = (dateString: LocalDateTime) => {
  const endDate = new Date(dateString)
  const endDateMinusOneHour = new Date(endDate.setHours(endDate.getHours() - 1)).toISOString() as LocalDateTime
  return endDateMinusOneHour
}

export const increaseDateByOneHour = (dateString: LocalDateTime) => {
  const endDate = new Date(dateString)
  const endDateMinusOneHour = new Date(endDate.setHours(endDate.getHours() + 1)).toISOString() as LocalDateTime
  return endDateMinusOneHour
}

export const getMonthsDifference = (startDate: JSJodaLocalDateTime, endDate: JSJodaLocalDateTime) => {
  const startLocalDate = startDate.toLocalDate()
  const endLocalDate = endDate.toLocalDate()

  const period = Period.between(startLocalDate, endLocalDate)
  return period.years() * 12 + period.months()
}
